import i18n from "../../i18n";

export function getDateFromDate(date:Date):String {
    return date.toLocaleDateString(i18n.resolvedLanguage);
}

export function getTimeFromDate(date:Date):String {
    return date.toLocaleTimeString(i18n.resolvedLanguage);
}

export function getDateTimeFromDate(date:Date):String {
    return getDateFromDate(date) + ' ' + getTimeFromDate(date);
}

export function isValidDate(d:Date):Boolean {
  return d instanceof Date && !isNaN(d.getTime());
}